import React from 'react';
import PropTypes from 'prop-types';

import { Box, Button, Card, CardActions, CardContent, CardMedia, Typography } from '@mui/material';
import { isEmpty, map } from 'lodash';
import { useTranslation } from 'react-i18next';
import { useStyles } from '../../../styles/mapStylesCustom';
import TutorialModal from './TutorialModal';

const HomeMaps = ({ userControlSetting = {} }) => {
  const { t } = useTranslation();
  const [openModal, setOpenModal] = React.useState(false);
  const [propertiesToPass, setPropertiesToPass] = React.useState([]);
  const isMobile = window.innerWidth < 500;
  const classes = useStyles();

  const handleOpenModal = properties => {
    setPropertiesToPass(properties);
    setOpenModal(true);
  };

  if (isEmpty(userControlSetting) || isEmpty(userControlSetting.tutorial)) {
    return null;
  }

  return (
    <Box
      display="flex"
      justifyContent="center"
      flexDirection={isMobile ? 'column' : 'row'}
      sx={{ marginTop: '5%' }}
    >
      {map(userControlSetting.tutorial, item => (
        <Card
          key={item.title}
          sx={{
            display: 'flex',
            flexDirection: isMobile ? 'row' : 'column',
            borderRadius: 4,
            margin: 'auto',
            mb: isMobile ? 2 : 0,
            maxWidth: isMobile ? '100%' : '15%'
          }}
        >
          <CardMedia
            sx={isMobile ? { flex: '0 0 auto', width: '50%' } : { height: 0, paddingTop: '100%' }}
            image={item.imagen}
            title={item.title}
          />
          <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
            <CardContent>
              <Typography component="div" variant="h6">
                {item.title}
              </Typography>
              <Typography color="text.secondary" component="div" variant="subtitle1">
                {item.description}
              </Typography>
            </CardContent>
            <CardActions sx={{ justifyContent: 'center', pl: 1, pb: 1 }}>
              <Button
                className={classes.azulIpsilumButton}
                size="small"
                onClick={() => handleOpenModal(item.properties)}
              >
                {t('tutorial')}
              </Button>
            </CardActions>
          </Box>
        </Card>
      ))}

      <TutorialModal
        openModal={openModal}
        setOpenModal={setOpenModal}
        properties={propertiesToPass}
      />
    </Box>
  );
};

HomeMaps.defaultProps = {
  userControlSetting: {}
};
HomeMaps.propTypes = {
  userControlSetting: PropTypes.object
};

export default HomeMaps;
